<template>
  <v-text-field
    :value="value"
    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
    :type="show1 ? 'text' : 'password'"
    :label="label"
    :outlined="outlined"
    :dense="dense"
    :error-messages="errorMessages"
    :maxlength="maxLength"
    @click:append="show1 = !show1"
    @input="(value) => $emit('input', value)"
  ></v-text-field>
</template>

<script>
export default {
  name: 'PasswordInput',
  props: {
    value: { type: String, default: null },
    label: { type: String, default: null },
    outlined: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    maxLength: { type: Number, default: undefined },
    errorMessages: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    show1: false,
  }),
};
</script>

<style></style>
